export const indexedSet = <T>(entries?: Iterable<[string, T]>) => {
  const map = new Map<string, Set<T>>();
  let size = 0;

  const add = (id: string, value: T) => {
    const current = map.get(id);
    if (current) {
      const sizeBefore = current.size;

      current.add(value);

      if (sizeBefore < current.size) {
        size++;
      }
    } else {
      map.set(id, new Set([value]));
      size++;
    }
  };

  const del = (id: string, value: T) => {
    const set = map.get(id);

    const didDelete = set?.delete(value);

    if (!didDelete) {
      return;
    }

    if (set?.size === 0) {
      map.delete(id);
    }

    size--;
  };

  if (entries) {
    for (const [id, value] of entries) {
      add(id, value);
    }
  }

  return {
    size: () => size,
    has: (id: string, value: T) => map.get(id)?.has(value) ?? false,
    get: (id: string) => map.get(id),
    add,
    delete: del,
    entries: () => map.entries(),
    *[Symbol.iterator]() {
      for (const [id, set] of map) {
        for (const value of set) {
          yield [id, value] as [string, T];
        }
      }
    },
  };
};

export type IndexedSet<T> = ReturnType<typeof indexedSet<T>>;
